import { render, staticRenderFns } from "./SelectListItemDatiMonitoring.vue?vue&type=template&id=6b385d07&"
import script from "./SelectListItemDatiMonitoring.vue?vue&type=script&lang=js&"
export * from "./SelectListItemDatiMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports